<ng-container *transloco="let t; read: 'companies'">
  @if (active) {
    <kendo-dialog (close)="closeForm()" [width]="450">
      <kendo-dialog-titlebar>
        {{ isNew ? t('createNewEmployee') : t('titleEditPopup') }}
      </kendo-dialog-titlebar>
      <form novalidate class="k-form" [formGroup]="editForm">
        <kendo-formfield>
          <kendo-label [for]="firstName" [text]="t('firstName')"></kendo-label>
          <kendo-textbox
            formControlName="firstName"
            #firstName
            >
          </kendo-textbox>
          <kendo-formhint>{{t('firstNameHint')}}</kendo-formhint>
          <kendo-formerror>{{t('firstNameError')}}</kendo-formerror>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-label [for]="lastName" [text]="t('lastName')"></kendo-label>
          <kendo-textbox
            formControlName="lastName"
            #lastName
            >
          </kendo-textbox>
          <kendo-formhint>{{t('lastNameHint')}}</kendo-formhint>
          <kendo-formerror>{{t('lastNameError')}}</kendo-formerror>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-label [for]="role" [text]="t('role')"></kendo-label>
          <kendo-textbox
            formControlName="role"
            #role>
          </kendo-textbox>
          <kendo-formhint>{{t('roleHint')}}</kendo-formhint>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-label [for]="phoneNumber" [text]="t('phoneNumber')"></kendo-label>
          <kendo-maskedtextbox
            formControlName="phoneNumber"
            [mask]="phoneNumberMask"
            #phoneNumber>
          </kendo-maskedtextbox>
          <kendo-formhint>{{t('phoneNumberHint')}}</kendo-formhint>
          @if (editForm.get('phoneNumber').hasError('pattern') && (editForm.get('phoneNumber')?.touched || editForm.get('phoneNumber')?.dirty)) {
            <kendo-formerror>{{t('phoneWrongFormatOrLenght')}}</kendo-formerror>
          }
          @if (editForm.get('phoneNumber').hasError('phoneNumberExists') && (editForm.get('phoneNumber')?.touched || editForm.get('phoneNumber')?.dirty)) {
            <kendo-formerror>{{t('phoneNumberAlreadyExists')}}</kendo-formerror>
          }
        </kendo-formfield>
        <kendo-formfield>
          <kendo-label [for]="language" [text]="t('language')"></kendo-label>
          <kendo-dropdownlist
            formControlName="language"
            #language
            [data]="languages"
            valueField="id"
            textField="name"
            [valuePrimitive]="true"
          ></kendo-dropdownlist>
          <kendo-formhint>{{t('languageHint')}}</kendo-formhint>
        </kendo-formfield>
        @if (isNew) {
          <kendo-formfield>
            <kendo-label [for]="email" [text]="t('email')"></kendo-label>
            <kendo-textbox formControlName="email" #email>
            </kendo-textbox>
            <kendo-formhint>{{t('emailHint')}}</kendo-formhint>
            @if (editForm.get('email').hasError('required')) {
              <kendo-formerror>{{t('isRequired')}}</kendo-formerror>
            }
            @if (editForm.get('email').hasError('email')) {
              <kendo-formerror>{{t('emailWrongFormat')}}</kendo-formerror>
            }
            @if (editForm.get('email').hasError('emailExists')) {
              <kendo-formerror>{{t('emailAlreadyExists')}}</kendo-formerror>
            }
          </kendo-formfield>
        }
        @if (isNew) {
          <kendo-formfield>
            <kendo-label
              [for]="password"
              [text]="t('password')">
            </kendo-label>
            <input
              kendoTextBox
              type="password"
              formControlName="password"
              #password
              >
              <kendo-formhint>{{t('passwordHint')}}</kendo-formhint>
              <kendo-formerror>{{t('passwordError')}}</kendo-formerror>
            </kendo-formfield>
          }
          @if (isNew) {
            <kendo-formfield>
              <kendo-label
                [for]="confirmPassword"
                [text]="t('confirmPassword')"
              ></kendo-label>
              <input
                kendoTextBox
                type="password"
                formControlName="confirmPassword"
                #confirmPassword
                >
                <kendo-formhint>{{t('confirmPasswordHint')}}</kendo-formhint>
                @if (editForm.get('confirmPassword').hasError('required')) {
                  <kendo-formerror>{{t('isRequired')}}</kendo-formerror>
                }
              </kendo-formfield>
            }
            @if (passwordMatchError) {
              <kendo-formerror>{{t('passwordMatchError')}}</kendo-formerror>
            }
            <kendo-dialog-actions>
              <button
                kendoButton
                class="buttonPrimary"
                [disabled]="!editForm.valid || editForm.pristine"
                (click)="onSave($event)">
                {{t('save')}}
              </button>
              <button
                kendoButton
                (click)="onCancel($event)"
                class="buttonSecondary">
                {{t('cancel')}}
              </button>
            </kendo-dialog-actions>
          </form>
        </kendo-dialog>
      }
    </ng-container>